import { useCallback } from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import Loading from '@/components/general/Loading';
import SeminarCard, { SeminarCardType } from '@/components/SeminarCard';
import useSidebarStatus from '@/hooks/useSidebarStatus';
import * as Styles from './SeminarsList.styles';

type SeminarsListType = {
  listOfSeminars: SeminarCardType[];
  isLoading: boolean;
};

const SeminarsListComponent = function ({
  isLoading,
  listOfSeminars,
}: SeminarsListType): JSX.Element {
  const sidebarStatus = useSidebarStatus();
  const renderSeminarCards = useCallback((props, index) => {
    return <SeminarCard data-testid="seminar-list-card" key={index} {...props} />;
  }, []);

  if (isLoading) {
    return <Loading fullPage />;
  }

  return (
    <div data-testid="seminar-list">
      <Styles.PageTitle data-testid="seminar-list-title">Seminars</Styles.PageTitle>
      <SimpleGrid
        spacingX={10}
        spacingY={16}
        columns={{ sm: 1, md: 3, lg: sidebarStatus.isSidebarOpen ? 3 : 4, '2xl': 4 }}
      >
        {listOfSeminars.map(renderSeminarCards)}
      </SimpleGrid>
    </div>
  );
};

export default SeminarsListComponent;
